 /*
  * Attribute-Typen:
  * 1 - SERIAL
  * 2 - INTEGER
  * 3 - VARCHAR
  * 4 - TIMESTAMP
  * 5 - DATE
  * 6 - TEXT
  * 7 - NUMERIC
  *
  * ['NAME']    = $attribute[0];
  * ['TITLE']   = $attribute[1];
  * ['TYPE']    = $attribute[2];
  * ['LENGTH']  = $attribute[3];
  * ['PK']      = $attribute[4];
  * ['FK']      = $attribute[5];
  * ['DEFAULT'] = $attribute[6];
  * ['NULL']    = $attribute[7];
  * ['T_NAME']  = $attribute[8];  =>  SELECT column AS T_NAME
  * ['UNIQUE']  = $attribute[9];
  * ['FORMULA'] = $attribute['formula'];
  * ['CLASS'] = $attribute['class'];
  */

  export const systemdata_definitions = {
    hotelcodes:   { 
      name: 'Hotelcodes',         
      table: 'icmp006.system_object_codes',
      defaultSorting: 'code',
      displayAs: 'table',
      columns: [
        { NAME: "id",     TITLE: "ID",          TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false, FK: false },
        { NAME: "code",   TITLE: "Hotelcode",   TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: false, FK: false },
        { NAME: "zgb_id", TITLE: "Zielgebiet",  TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,  FK: { TABLE: 'destinations', FK: 'zgbid', COLUMN_TO_DISPLAY: 'name' } },
      ]
    },

    rooms: { 
      name: 'Zimmer',
      table: 'icmp006.system_zimmerart_neu',
      defaultSorting: 'zimmerart_name_eng',
      displayAs: 'table',
      readonly: true,
      columns: [
        { NAME: "id",                 TITLE: "ZGB-ID",      TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "zimmerart_name",     TITLE: "Bezeichnung", TYPE: 3, LENGTH: 50,    PK: false, UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "zimmerart_name_eng", TITLE: "Code",        TYPE: 3, LENGTH: 2,     PK: false, UNIQUE: false, NULL: false,  FK: false }
      ]
    },

    destinations: { 
      name: 'Zielgebiete',
      table: 'icmp_zgbs',
      defaultSorting: 'name',
      displayAs: 'table',
      columns: [
        { NAME: "zgbid",                TITLE: "ZGB-ID",            TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "name",                 TITLE: "3LC",               TYPE: 3, LENGTH: 50,    PK: false, UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "description",          TITLE: "Beschreibung",      TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "zgb_land_id",          TITLE: "Land",              TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'country', FK: 'land_id', COLUMN_TO_DISPLAY: 'land_name' } },
        { NAME: "zgb_mind_aufenthalt",  TITLE: "Mindestaufenthalt", TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },

    country: { 
      name: 'Land',
      table: 'icmp006.system_land',
      defaultSorting: 'land_id',
      displayAs: 'table',
      columns: [
        { NAME: "land_id",            TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "land_name",          TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "landkuerzel",        TITLE: "Kürzel",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "land_tel_lvwahl",    TITLE: "Landsesvorwahl",      TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
      ]
    },

    seasons: { 
      name: 'Saison',
      table: 'icmp006.system_saison',
      defaultSorting: 'reihenfolge',
      displayAs: 'table',
      columns: [
        { NAME: "saison_id",          TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "kuerzel",            TITLE: "Kürzel",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "name",               TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "reihenfolge",        TITLE: "Reihenfolge",         TYPE: 2, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
      ]
    },

    tags: { 
      name: 'Schlagworte',
      table: 'system.system_schlagworte',
      defaultSorting: 'name',
      displayAs: 'table',
      columns: [
        { NAME: "id",                 TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "name",               TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
      ]
    },

    currency: { 
      name: 'Währung',
      table: 'icmp006.system_waehrung',
      defaultSorting: 'name',
      displayAs: 'table',
      columns: [
        { NAME: "id",                 TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "nummer",             TITLE: "Nummer",              TYPE: 2, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "kuerzel",            TITLE: "Kürzel",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "name",               TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "symbol_html",        TITLE: "Symbol",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
      ]
    },

    agency: { 
      name: 'Agentur',
      table: 'icmp006.system_agentur',
      defaultSorting: 'code',
      displayAs: 'single',
      titleColumn: 'vertreter',
      columns: [
        { NAME: "id",                     TITLE: "ID",                          TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "vertreter",              TITLE: "vertreter",                   TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "code",                   TITLE: "Agentur-Code",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "strasse",                TITLE: "Straße",                      TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "plz",                    TITLE: "Plz",                         TYPE: 3, LENGTH: 10,    PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "ort",                    TITLE: "Ort",                         TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "land",                   TITLE: "Land",                        TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "telefon",                TITLE: "Telefon",                     TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "notfalltelefon",         TITLE: "Notfall-Telefon",             TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "telefax",                TITLE: "Telefax",                     TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "email",                  TITLE: "E-Mail",                      TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "homepage",               TITLE: "Homepage",                    TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "buchungskonto",          TITLE: "Buchungskonto",               TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "meldungsmail",           TITLE: "Meldungsmail",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_bustransfer",      TITLE: "Infos zum Bustransfer",       TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_bustransfer_abh",  TITLE: "Infos zum Bustransfer ABH",   TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_bustransfer_hlx",  TITLE: "Infos zum Bustransfer HLX",   TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_bustransfer_lhh",  TITLE: "Infos zum Bustransfer LHH",   TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_taxitransfer",     TITLE: "Infos zum Taxitransfer",      TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_taxitransfer_abh", TITLE: "Infos zum Taxitransfer ABH",  TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_taxitransfer_hlx", TITLE: "Infos zum Taxitransfer HLX",  TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_taxitransfer_lhh", TITLE: "Infos zum Taxitransfer LHH",  TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_reiseleitung",     TITLE: "Infos zur Reiseleitung",      TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_reiseleitung_abh", TITLE: "Infos zur Reiseleitung ABH",  TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_reiseleitung_hlx", TITLE: "Infos zur Reiseleitung HLX",  TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_reiseleitung_lhh", TITLE: "Infos zur Reiseleitung LHH",  TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "infos_intern",           TITLE: "Infos Intern",                TYPE: 6, LENGTH: false, PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "rbs_code",               TITLE: "RBS Code Agentur",            TYPE: 3, LENGTH: 4,     PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "rbs_code_handling",      TITLE: "RBS Code Handling",           TYPE: 3, LENGTH: 4,     PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "rbs_code_bustransfer",   TITLE: "RBS Code Bustransfer",        TYPE: 3, LENGTH: 4,     PK: false, UNIQUE: true,  NULL: true,   FK: false },
        { NAME: "rbs_code_taxitransfer",  TITLE: "RBS Code Taxitransfer",       TYPE: 3, LENGTH: 4,     PK: false, UNIQUE: true,  NULL: true,   FK: false },
      ]
    },

    handlingfee: { 
      name: 'Handling-Fee',
      table: 'system.system_handlingfee',
      defaultSorting: 'sys_id',
      displayAs: 'table',
      titleColumn: 'sys_name_blank',
      columns: [
        { NAME: "sys_id",             TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "sys_id_saison",      TITLE: "Saison",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: false,  FK: { TABLE: 'seasons', FK: 'saison_id', COLUMN_TO_DISPLAY: 'kuerzel' } },
        { NAME: "sys_id_zgb",         TITLE: "Zielgebiet",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'destinations', FK: 'zgbid', COLUMN_TO_DISPLAY: 'name' } },
        { NAME: "sys_name_blank",     TITLE: "Name Blank",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_value_adult",    TITLE: "Wert Erwachsener",    TYPE: 7, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_value_child",    TITLE: "Wert Kind",           TYPE: 7, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_id_currency",    TITLE: "Währung",             TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'currency', FK: 'id', COLUMN_TO_DISPLAY: 'kuerzel' } },
        { NAME: "sys_gueltigkeit",    TITLE: "Gültigkeit (t-> pro Tag, a-> pro Aufenthalt)", TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "id_system_agentur",  TITLE: "Agentur",             TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'agency', FK: 'id', COLUMN_TO_DISPLAY: 'code' } },
      ]
    },
    /*
    lturzuschlag: { 
      name: 'LTUR-Zuschlag',
      table: 'icmp006.system_lturzuschlag',
      defaultSorting: 'id',
      displayAs: 'table',
      columns: [
        { NAME: "id",                 TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "zgb",                TITLE: "DLC",                 TYPE: 3, LENGTH: 3,     PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'destinations', FK: 'zgbid', COLUMN_TO_DISPLAY: 'name' } },
        { NAME: "zuschlag",           TITLE: "Zuschlag",            TYPE: 7, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "id_system_waehrung", TITLE: "Währung",             TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'currency', FK: 'id', COLUMN_TO_DISPLAY: 'kuerzel' } },
      ]
    },
    */
    transfer_bus: { 
      name: 'Bus-Transfer',
      table: 'system.system_transfer',
      defaultSorting: 'sys_id',
      displayAs: 'table',
      titleColumn: 'sys_name_blank',
      columns: [
        { NAME: "sys_id",             TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "sys_id_saison",      TITLE: "Saison",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: false,  FK: { TABLE: 'seasons', FK: 'saison_id', COLUMN_TO_DISPLAY: 'kuerzel' } },
        { NAME: "sys_id_zgb",         TITLE: "Zielgebiet",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'destinations', FK: 'zgbid', COLUMN_TO_DISPLAY: 'name' } },
        { NAME: "sys_name_blank",     TITLE: "Name Blank",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_value_adult",    TITLE: "Wert Erwachsener",    TYPE: 7, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_value_child",    TITLE: "Wert Kind",           TYPE: 7, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_id_currency",    TITLE: "Währung",             TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'currency', FK: 'id', COLUMN_TO_DISPLAY: 'kuerzel' } },
        { NAME: "id_system_agentur",  TITLE: "Agentur",             TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'agency', FK: 'id', COLUMN_TO_DISPLAY: 'code' } },
        { NAME: "info",               TITLE: "Info Fremdtransfer",  TYPE: 3, LENGTH: 60,    PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },

    transfer_taxi: { 
      name: 'Taxi-Transfer',
      table: 'system.system_transfer_taxi',
      defaultSorting: 'sys_name',
      displayAs: 'table',
      titleColumn: 'sys_name',
      columns: [
        { NAME: "sys_id",             TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "sys_name",           TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "sys_date_from",      TITLE: "Datum von",           TYPE: 5, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_date_to",        TITLE: "Datum bis",           TYPE: 5, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_value_adult",    TITLE: "Preis pro Taxi",      TYPE: 7, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "sys_id_currency",    TITLE: "Währung",             TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'currency', FK: 'id', COLUMN_TO_DISPLAY: 'kuerzel' } },
        { NAME: "id_system_agentur",  TITLE: "Agentur",             TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'agency', FK: 'id', COLUMN_TO_DISPLAY: 'code' } },
        { NAME: "info",               TITLE: "Info Fremdtransfer",  TYPE: 3, LENGTH: 60,    PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },
    
    hotelchain: { 
      name: 'Hotelketten',
      table: 'icmp006.system_hotelkette',
      defaultSorting: 'hotelkette_name',
      displayAs: 'table',
      columns: [
        { NAME: "hotelkette_id",      TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "hotelkette_name",    TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },

    hoteltyp: { 
      name: 'Hoteltyp',
      table: 'icmp006.system_hoteltyp',
      defaultSorting: 'hoteltyp_name',
      displayAs: 'table',
      columns: [
        { NAME: "hoteltyp_id",        TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "hoteltyp_name",      TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "hoteltyp_abk",       TITLE: "Kürzel",              TYPE: 3, LENGTH: 10,    PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },

    category_int: { 
      name: 'Kategorie (int)',
      table: 'icmp006.system_kategorie',
      defaultSorting: 'kategorie_sterne',
      displayAs: 'table',
      columns: [
        { NAME: "kategorie_id",       TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "kategorie_sterne",   TITLE: "Sterne",              TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "kategorie_name",     TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },

    category_off: { 
      name: 'Kategorie (off)',
      table: 'icmp006.system_kategorie_blank',
      defaultSorting: 'kategorie_sterne',
      displayAs: 'table',
      columns: [
        { NAME: "kategorie_id",       TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "kategorie_sterne",   TITLE: "Sterne",              TYPE: 3, LENGTH: 10,    PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "kategorie_name",     TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },
    
    city: { 
      name: 'Orte',
      table: 'icmp006.system_ort',
      defaultSorting: 'ort_name',
      displayAs: 'table',
      columns: [
        { NAME: "ort_id",             TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "ort_name",           TITLE: "Name",                TYPE: 3, LENGTH: 10,    PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "zgb_3lc",            TITLE: "Zielgebiet",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'destinations', FK: 'zgbid', COLUMN_TO_DISPLAY: 'name' } },
        { NAME: "ort_kostentabelle",  TITLE: "Kostentabelle",       TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },

    board: { 
      name: 'Verpflegungen',
      table: 'icmp006.system_verpflegung',
      defaultSorting: 'reihenfolge',
      displayAs: 'table',
      columns: [
        { NAME: "id",                 TITLE: "ID",                  TYPE: 1, LENGTH: false, PK: true,  UNIQUE: true,  NULL: false,  FK: false },
        { NAME: "verpfl_abk",         TITLE: "Kürzel",              TYPE: 3, LENGTH: 10,    PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "verpfl_blank",       TITLE: "Blank-Abk.",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: { TABLE: 'destinations', FK: 'zgbid', COLUMN_TO_DISPLAY: 'name' } },
        { NAME: "verpfl_name",        TITLE: "Name",                TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "reihenfolge",        TITLE: "Reihenfolge",         TYPE: 2, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
        { NAME: "verpfl_name_eng",    TITLE: "Name Engl.",          TYPE: 3, LENGTH: false, PK: false, UNIQUE: false, NULL: true,   FK: false },
      ]
    },
  }

  
  export const systemdata_groups = {
    global: [
      { key: 'hotelcodes',    name: 'Hotelcodes',         table: 'icmp006.system_object_codes' },
      { key: 'seasons',       name: 'Saisons',            table: 'icmp006.system_saison' },
      { key: 'destinations',  name: 'zielgebiete',        table: 'icmp_zgbs' }
    ],
    object: [
      { key: 'handlingfee',   name: 'Handling Fee',       table: 'system.system_handlingfee' },
      /*{ key: 'lturzuschlag',  name: 'LTUR-Zuschlag',      table: 'icmp006.system_lturzuschlag' },*/
      { key: 'transfer_bus',  name: 'Bus-Transfer',       table: 'system.system_transfer' },
      { key: 'transfer_taxi', name: 'taxi-transfer',      table: 'system.system_transfer_taxi' }
    ],
    contract: [
      { key: 'agency',        name: 'Agentur',            table: 'icmp006.system_agentur' },
      { key: 'hotelchain',    name: 'Hotelketten',        table: 'system.system_hotelkette' },
      { key: 'hoteltyp',      name: 'Hoteltyp',           table: 'system_hoteltyp' },
      { key: 'category_int',  name: 'Kategorie (int)',    table: 'icmp006.system_kategorie' },
      { key: 'category_off',  name: 'Kategorie (off)',    table: 'icmp006.system_kategorie_blank' },
      { key: 'country',       name: 'Land',               table: 'icmp006.system_land' },
      { key: 'city',          name: 'Ort',                table: 'icmp006.system_ort' },
      { key: 'board',         name: 'Verpflegung',        table: 'icmp006.system_verpflegung' },
      { key: 'currency',      name: 'Währung',            table: 'icmp006.system_waehrung' },
      { key: 'rooms',         name: 'Zimmer',             table: 'icmp006.system_zimmerart_neu' },
    ]
  }